module.exports = __webpack_public_path__ + "img/9.17d221e9.png";